<template>
  <modal
      :linkClass="'action-icon'"
      :modalId="name"
      :title="title"
      :modalSize="'large'"
      :footer="true"
  >
    <template slot="modalBody">
      <form v-on:submit.prevent="$emit('saveChanges')">
        <div class="form-group">
          <div class="edit-upload-image upload-image-file" v-if="user" @click="triggerImageUpload">
            <label class="label-upload-image">
                            <span class="wrap-upload-image">
                                <span class="helper-img"></span>
                                <template v-if="tempImage">
                                    <img :src="tempImage" alt="Profile picture2">
                                </template>
                                <template v-if="profilePicture.file && !tempImage">
                                    <img :src="profilePicture.url" alt="Profile picture3">
                                </template>
                            </span>
              <span class="edit-image-text">Bewerk foto</span>
            </label>
          </div>
          <picture-input
              v-if="user"
              class="d-none"
              ref="pictureInput"
              :crop="false"
              accept="image/*"
              @change="handleProfileFileChange">
          </picture-input>
        </div>
        <div class="form-group">
          <label :for="name+'-email'">Email</label>
          <input v-validate="'required'"
                 :name="name+'-email'"
                 :id="name+'-email'"
                 type="text"
                 class="form-control"
                 v-model="user.email"
                 disabled>
        </div>
        <div class="form-group">
          <label :for="name+'-fistname'">Voornaam</label>
          <input v-validate="'required'"
                 :name="name+'-fistname'"
                 :id="name+'-fistname'"
                 type="text"
                 class="form-control"
                 v-model="user.firstname">
        </div>
        <div class="form-group">
          <label :for="name+'-lastname'">Achternaam</label>
          <input v-validate="'required'"
                 :name="name+'-lastname'"
                 :id="name+'-lastname'"
                 type="text"
                 class="form-control"
                 v-model="user.lastname">
        </div>
        <div class="form-group">
          <label :for="name+'-mobile'">Mobiel</label>
          <input :name="name+'-mobile'"
                 :id="name+'-mobile'"
                 type="text"
                 class="form-control"
                 v-model="user.mobile">
        </div>
        <div class="form-group">
          <vue-multi-select
              ref="multiSelect"
              v-model="user.departments"
              :options="options"
              :filters="filters"
              :btnLabel="btnLabel"
              :selectOptions="selectOptions"
          >
            <template v-slot:option="{option}">
              <input type="checkbox" :checked="option.selected"/>
              <span>{{ option.name }}</span>
            </template>
          </vue-multi-select>
        </div>
        <div class="form-group" v-for="d in user.departments" :key="d.name">
          <label :for="name+'-role'">{{ d.name }} Role</label>
          <select v-model="user.roles[d.name]" class="form-control">
            <option disabled value="">Selecteer..</option>
            <option v-for="role in roles.filter((r) => r.department === d.name)" :value="role.id" :key="role.id">
              {{ role !== undefined ? role.name : '' }}
            </option>
          </select>
        </div>
      </form>
    </template>


    <div class="modal-footer" slot="modalFooter">
      <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
        Annuleren
      </button>
      <button type="button" class="btn btn-primary" :disabled="!user.email.length" @click="saveChanges"
              data-dismiss="modal">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>

    </div>
  </modal>
</template>

<script>
import {DEPARTMENTS} from '../../constants';
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import {swalModals} from '../mixins/swalModals';
import {imageOrientation} from '../mixins/imageOrientation';

const departmentOptions = DEPARTMENTS.map(d => {
  return {name: d}
})

export default {
  mixins: [imageOrientation, swalModals],
  watch: {
    user: {
        handler:function(newV,oldV){


        this.triggerReloadImage()
      },deep:true
    },
  },
  created() {
    this.triggerReloadImage()
    // const id = this.user.id
    // let ref = this.$FB_STORAGE.ref('');
    // let self = this;
    // let documentList = ref.child('user_pictures/' + id);
    // try {
    //   documentList.listAll().then(function (itemList) {
    //     itemList.items.forEach(function (itemRef) {
    //       itemRef.getDownloadURL().then((documentUrl) => {
    //         console.log(documentUrl)
    //         itemRef.getMetadata().then(meta => {
    //           console.log(meta)
    //           if (meta.customMetadata.profilePicture) {
    //             self.profilePicture = {
    //               profilePicture: true,
    //               name: meta.name,
    //               file: documentUrl,
    //               url: documentUrl,
    //               metaData: meta.customMetadata
    //             };
    //           }
    //         });
    //       });
    //     });
    //   }).catch(function (error) {
    //     console.log(error);
    //   });
    // } catch (e) {
    //   console.error('No profile pic', e)
    // }

  },
  data() {
    return {
      btnLabel: values => `Departments selected (${values ? values.length : "0"})`,
      selectOptions: departmentOptions,
      filters: [
        {
          nameAll: 'Select all',
          nameNotAll: 'Deselect all',
          func() {
            return true;
          },
        },
      ],
      options: {
        multi: true,
      },
      userBU: this.user,
      tempImage: null,
      profilePicture: {
        profilePicture: true,
        name: 'profilepicture',
        file: null,
      },
    }
  },
  props: ['index', 'title', 'user', 'roles', 'name'],
  methods: {
    triggerReloadImage() {
      const id = this.user.id
       let ref = this.$FB_STORAGE.ref('');
      let self = this;
      self.profilePicture = {
        profilePicture: false,
        name: null,
        file: null,
        url: null,
        metaData: null
      };
      let documentList = ref.child('user_pictures/' + id);
       try {
        documentList.listAll().then(function (itemList) {
          itemList.items.forEach(function (itemRef) {
            itemRef.getDownloadURL().then((documentUrl) => {
                itemRef.getMetadata().then(meta => {
                 if (meta.customMetadata.profilePicture) {
                  self.profilePicture = {
                    profilePicture: true,
                    name: meta.name,
                    file: documentUrl,
                    url: documentUrl,
                    metaData: meta.customMetadata
                  };
                }
              });
            });
          });
        }).catch(function (error) {
          console.log(error);
        });
      } catch (e) {
        console.error('No profile pic', e)
      }
    },

    triggerImageUpload() {
      this.$refs.pictureInput.$refs.fileInput.click();
    },
    handleProfileFileChange() {
      this.$store.commit('setLoading', true);
      this.profilePicture.file = this.$refs.pictureInput.file;

      let file = this.profilePicture.file;

      let ImgCheck = this.$refs.pictureInput;

      ImgCheck.getEXIFOrientation(file, (orientation) => {

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              var base64 = reader.result;
              this.resetOrientation(base64, orientation, (resetBase64Image) => {

                this.profilePicture.file = this.dataURItoBlob(resetBase64Image);
                this.tempImage = resetBase64Image;
                this.profilePicture.path = '/candidates/' + this.id + '/';
                delete this.profilePicture.metaData;

                this.$FB_UPLOADER.upload(this.profilePicture).then(() => {
                  this.$store.commit('setLoading', false);
                }).catch(() => {
                  this.$toasted.global.failedRequest();
                });
              });
            };
          }
      );
    },
    saveChanges() {
      this.profilePicture.name = this.user.id
      let docRef = this.user.id

      let documentArray = []
      if (this.profilePicture.file) {
        documentArray.push(this.profilePicture)
      }
      _.each(documentArray, (doc) => {
        doc.path = '/user_pictures/' + docRef + '/';
      });
      this.$FB_UPLOADER.upload(documentArray).then(res => {
        this.$emit('saveChanges', this.user);
      })
    }
  },
  components: {
    vueMultiSelect,
  },
  beforeRouteLeave(to, from, next) {
    if (this.disableNavigation) {
      this.swalUnsavedChanges().then(result => {
        if (result.value) {
          next();
          this.customer = this.customerCopy;
        }
      });
    } else {
      next();
    }
  },
}
</script>